import React, { createContext, useContext, useState, useEffect } from 'react';
import { pagesConfig } from '../pages.config';

const NavigationContext = createContext(null);

export function NavigationProvider({ children }) {
  const { Pages, mainPage } = pagesConfig;
  const initialPage = mainPage || Object.keys(Pages)[0];
  const [currentPage, setCurrentPage] = useState(initialPage);

  const navigateTo = (pageName) => {
    if (Pages[pageName]) {
      setCurrentPage(pageName);
    } else {
      console.warn(`Page ${pageName} not found.`);
    }
  };

  return (
    <NavigationContext.Provider value={{ currentPage, navigateTo }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}
